import React from "react";
import "../scss/about-young-company.scss";

const PresentationContainer = ({ title, about, img }) => {
  return (
    <div className="about-container">
      <div className="main-container">
        <h1 className="title">{title}</h1>
        <div className="presentation">{about}</div>
      </div>
      <div
        className="illustration"
        style={{
          backgroundImage: "url(../assets/{img}))",
        }}
      ></div>
    </div>
  );
};

export default PresentationContainer;
